// React
import React, { useState } from 'react';

import Combobox from '@cybs-ui/components/lib/combobox';
import {getExampleParentName,getExampleSummary,getSelectedSampleCode,getFirstLevelKey,getSecondLevelKey,getThirdLevelKey, getExampleRestructuredData, getAllExamplesData, getExampleKey} from '../../../reducers/examples-reducer';
import {getJsTree} from '../../../reducers/rhs-schema-reducer';
import {getSecondLevelKeyFlag} from '../../../../../lhs/reducers/lhs-reducer';
import {updateSpecBasedExampleData} from '../../../actions/rhs-schema-actions';
import {putDataInDevCenterDataStore} from '../../../../../app/store';
import {connect} from 'react-redux';
import $ from 'jquery';
import '../../rhs-components/css/live-console.css'
import '../../../../../rhs/css/rhs.css';
import {initiateSampleCodeEvent} from '../../../../../commons/sample-code';
import {replaceSpace, setWindowLocationHash} from '../../../../../../src/libs/common-library';

var selectedItems = [];
let exampleData = [];
let sampleRequestDropDownExamplesData = [];


function extractprocessorSpecificExample(examplesDataInfo, selectedProcessorLabel) {
  const processorSpecificExampleData = [];
  const nonProcessorSpecificExampleData = [];
  const processedParentTags = new Set();

  examplesDataInfo.forEach(example => {
    let hasProcessorType = false;
    if (example['processorType'] && selectedProcessorLabel.trim() !== '' && example['processorType'].includes(selectedProcessorLabel)) {
      processorSpecificExampleData.push(example);
      hasProcessorType = true;
    }
    if (example['children']) {
      // Skip duplicate parent tags
      if (processedParentTags.has(example.label)) {
        return;
      }

      const childExamples = example['children'].filter(child => {
        if (child['processorType'] && selectedProcessorLabel.trim() !== '' && child['processorType'].includes(selectedProcessorLabel)) {
          hasProcessorType = true;
          return true;
        }
        return false;
      });

      if (childExamples.length > 0) {
        processorSpecificExampleData.push({...example, children: childExamples});
        processedParentTags.add(example.label);
      } else {
        const nonProcessorChildExamples = example['children'].filter(child => !child['processorType']);
        if (nonProcessorChildExamples.length > 0) {
          nonProcessorSpecificExampleData.push({...example, children: nonProcessorChildExamples});
          processedParentTags.add(example.label);
        }
      }
    }

    if (!hasProcessorType && !example['processorType']) {
      nonProcessorSpecificExampleData.push(example);
    }
  });

  // Remove any duplicate parent tags from both arrays
  const uniqueProcessorSpecific = processorSpecificExampleData.filter((example, index, self) => 
    index === self.findIndex((t) => t.label === example.label)
  );
  
  const uniqueNonProcessorSpecific = nonProcessorSpecificExampleData.filter((example, index, self) => 
    index === self.findIndex((t) => t.label === example.label)
  );

  sampleRequestDropDownExamplesData = (uniqueProcessorSpecific.length > 0 && selectedProcessorLabel && 
    selectedProcessorLabel.trim() !== '') ? uniqueProcessorSpecific : uniqueNonProcessorSpecific;

}

class MultiExample extends React.Component {

  // MultiExample(){
  //   this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
  // }

  // forceUpdateHandler(){
  //   this.forceUpdate();
    
  // };

  constructor(props) {
    super(props);
    this.state = {
      selectedItems: []
    };
  }
 
  componentDidMount() {
    this.updateSelectedItems();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedProcessorLabel !== this.props.selectedProcessorLabel) {
      this.updateSelectedItems();
    }
  }

  updateSelectedItems() {
    const { selectedProcessorLabel, examplesData } = this.props;
    const processorSpecificExampleData = examplesData.reduce((acc, example) => {
      if (example['processorType'] && selectedProcessorLabel.trim() !== '' && example['processorType'].includes(selectedProcessorLabel)) {
        acc.push(example);
      }
      if (example['children']) {
        const childExamples = example['children'].filter(child => child['processorType'] && selectedProcessorLabel.trim() !== '' && child['processorType'].includes(selectedProcessorLabel));
        if (childExamples.length > 0) {
          acc.push({ ...example, children: childExamples });
        }
      }
      return acc;
    }, []);

    extractprocessorSpecificExample(this.props.examplesData, selectedProcessorLabel);

    const selectedItem = sampleRequestDropDownExamplesData[0];
    const selectedItems = [selectedItem];

    this.setState({ selectedItems });
    if (selectedItems[0] && selectedItems[0].children && selectedItems[0].children.length > 0) {
      updateCurrentExampleInStore([selectedItems[0].children[0]]);
    } else {
      updateCurrentExampleInStore(selectedItems);
    }
  }

  render(){
    const { selectedProcessorLabel } = this.props;
    const { selectedItems } = this.state;

    return(
      (() => {
        if(this.props != undefined){
          if(this.props.examplesData != undefined && this.props.examplesData.length > 0){
            extractprocessorSpecificExample(this.props.examplesData, selectedProcessorLabel);

            if(!isEqualArrays(exampleData,sampleRequestDropDownExamplesData)){
              exampleData = sampleRequestDropDownExamplesData;
              this.setState({ selectedItems: [sampleRequestDropDownExamplesData[0]] });
            }

            const setSelection = (selected) => {
              this.setState({ selected: selected });
              this.setState({ selectedItems: selected });
              // by default select the first selected element in the list
              var selectedItemIndex = 0;
              
              // in case of nested elements, the first element is the parent, so selected the second one
              if(selected.length == 1){
                this.setState({ selectedItems: [selected[selectedItemIndex]] });
              }
              else{
                selectedItemIndex = 1;
                this.setState({ selectedItems: [selected[selectedItemIndex]] });
              }
              var hash = encodeURI(window.location.hash);
              var decodedHash = decodeURI(hash);
              updateCurrentExampleInStore(selected);
              var selectedSampleCode = getSelectedSampleCode();
              if(selectedSampleCode && selectedSampleCode != 'Live Console'){
                var secondLevelKey = getSecondLevelKeyFlag()?undefined:getSecondLevelKey();
                var sampleCodeName = (getExampleSummary() != undefined)?getExampleSummary():getThirdLevelKey();
                initiateSampleCodeEvent(replaceSpace(getThirdLevelKey()), getFirstLevelKey(), "extension" + selectedSampleCode, secondLevelKey, sampleCodeName);
                var urlHash;
                if(getExampleParentName() != undefined){
                    urlHash = replaceSpace(getFirstLevelKey()) +"_" + replaceSpace(getSecondLevelKey()) +"_"+ replaceSpace(getThirdLevelKey())+"_" + "samplerequests-dropdown_" + replaceSpace(getExampleParentName().toLowerCase().replace(/[\W_]+/g," ").replace("(","-").replace(")","-")) +"_"+ replaceSpace(sampleCodeName.toLowerCase().replace(/[\W_]+/g," ").replace("(","-").replace(")","-")) +"_"+ replaceSpace(selectedSampleCode).toLowerCase();
                }
                else{
                    urlHash = replaceSpace(getFirstLevelKey()) +"_" + replaceSpace(getSecondLevelKey()) +"_"+ replaceSpace(getThirdLevelKey())+"_" + "samplerequests-dropdown_" + replaceSpace(sampleCodeName.toLowerCase().replace(/[\W_]+/g," ").replace("(","-").replace(")","-")) +"_"+ replaceSpace(selectedSampleCode).toLowerCase();
                }
                setWindowLocationHash(urlHash.replace("-_","_"));
              }
              else{
                $('button[data-test^="heading-level-tabs-live-console-0"]').trigger('click');
              }
            };
          
            const handleSelection = (event, selected) => {
              if(selected.length>0 && !selected[selected.length - 1].hasNestedDropdown && JSON.stringify(selected[selected.length - 1])!='{}'){
                setSelection(selected);               
              }
            };
        
            const handleBlur = (event, invalid, selected) => {
              $("#sampleRequestDropDownDiv input").val(getExampleSummary())
            };

            return (
              <div class="sample-request-dropdown">
                <Combobox
                  i18n={{
                    label: 'Sample Request',
                  }}
                  dataTest="sample-request-combobox"
                  items={sampleRequestDropDownExamplesData}
                  onSelect={handleSelection}
                  selectedItems={selectedItems[0] && selectedItems[0].children ? selectedItems[0].children[0] : selectedItems }
                  type="nested"
                  onBlur={handleBlur}
                />
              </div>
            );
          }
          else{
            return(
              <span></span>
            )
          }

        }
        else{
          return(
            <span></span>
          )
        }
      })()
    )
  }

  
};
function isEqualArrays(arr1,arr2){
  if(arr1.length == arr2.length){
    for(var i=0; i<arr1.length; i++){
      if(arr1[i].label !== arr2[i].label){
        return false;
      }
    }
    return true;
  }
  return false;
}

function updateCurrentExampleInStore(selected){
  var selectedExample = selected[selected.length-1];
  var exampleData = getExampleDataUsingExampleId(selectedExample['value']);
  var currentExampleData = getExampleDataUsingExampleId(getExampleKey());
  if(selected.length>1){
    putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_PARENT_NAME',exampleParentName:selected[0]['label']});
  }
  else{
    putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_PARENT_NAME',exampleParentName:undefined});
  }
  putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_SUMMARY',exampleSummary:selectedExample['label']});
  putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_KEY',exampleKey:selectedExample['value']});
  if(!('requiredFields' in exampleData) && !('requiredFields' in currentExampleData)){
    updateSpecBasedExampleData(exampleData['value'],[],false);
  }
  else{
    var requiredFields = exampleData['requiredFields'];
    updateSpecBasedExampleData(exampleData['value'],requiredFields,true);
  }
}

function getExampleDataUsingExampleId(exampleId){
  var allExamplesData = getAllExamplesData();
  return allExamplesData[exampleId];
}

function mapStateToProps(state){
  return{
    examplesData: state.examplesReducer.exampleRestructuredData,
    exampleSummary: state.examplesReducer.exampleSummary,
    thirdLevelKey: state.examplesReducer.thirdLevelKey
  }
}

export default connect(mapStateToProps)(MultiExample);
export {getExampleDataUsingExampleId,updateCurrentExampleInStore}
